import { createContext, useContext } from 'react';

export const NavCollapsedContext = createContext(false);

export function useNavCollapsed(): boolean {
  return useContext(NavCollapsedContext);
}
